;(function () {
  'use strict'

  angular.module('contrast.protection').constant('PROTECTION_EVENTS', {
    STATE_UPDATED: 'protectionState:updated'
  })
})()
